import { lastLoginMethodClient, magicLinkClient } from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"

export const authClient = createAuthClient({
  baseURL: window.origin,
  basePath: "/api/auth",
  plugins: [lastLoginMethodClient(), magicLinkClient()],
})

export const { useSession, signIn, signOut } = authClient
